import React, { useMemo, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { HeaderWithBreadcrumbs } from "@mlpa/core-ui-core-open_ocean_ui/Organisms/HeaderAndNavigation/HeaderWithBreadcrumbs";
import translations from "translations";
import { useBreadcrumbs } from "./useBreadcrumbs";

export const MainLayoutHeader: React.FC = React.memo(() => {
  const breadcrumbs = useBreadcrumbs();
  const navigate = useNavigate();
  const location = useLocation();

  const handleBreadcrumbClick = useCallback(
    (event: React.MouseEvent, href: string) => {
      event.preventDefault();
      event.stopPropagation();
      // Always navigate using React Router to avoid page reloads
      navigate(href, { replace: location.pathname === href });
    },
    [navigate, location]
  );

  const breadcrumbsProps = useMemo(() => {
    const items = [
      {
        label: translations.pages.home.label,
        href: "/assetManagement",
        onClick: (e: React.MouseEvent) => handleBreadcrumbClick(e, "/assetManagement"),
      },
      ...breadcrumbs.map((crumb) => ({
        label: crumb.label,
        href: crumb.pathname,
        onClick: (e: React.MouseEvent) => handleBreadcrumbClick(e, crumb.pathname),
      })),
    ];

    return {
      items,
      sx: {
        "& .MuiBreadcrumbs-separator:last-of-type": {
          display: "none",
        },
      },
    };
  }, [breadcrumbs, handleBreadcrumbClick]);

  return <HeaderWithBreadcrumbs searchApp={false} languageSelector={false} breadcrumbsProps={breadcrumbsProps} />;
});

MainLayoutHeader.displayName = "MainLayoutHeader";
